import { getFormValues, hasSubmitFailed, isDirty, isPristine, isValid, reduxForm, clearSubmitErrors, setSubmitSucceeded } from 'redux-form'
import styles from './PromoForm.css'
import { connect } from 'react-redux'
import { onClickCancel } from 'actions/library/promo'
import { OverlayTrigger, Panel, PanelGroup, Tooltip } from 'react-bootstrap'
import {
  askConfirmationUpdate,
  onClickDeactivate,
  onClickDelete,
  onClickReactivate,
  onCreatePromoBuyXGetY,
  onSubmitFirstForm,
  onSubmitSecondForm,
  onSubmitThirdForm,
  onUpdatePromo,
  setAccordionActiveKey,
  setActionUpdateName,
  showConfirmReactivateModal
} from 'actions/library/promo/promo'
import PromoTypeAndName from './PromoTypeAndName'
import PurchaseRequirement from './PurchaseRequirement'
import Reward from './Reward'
import PromoConfiguration from './PromoConfiguration'
import moment from 'moment'
import { difference, includes, isEmpty, mapKeys } from 'lodash'
import { libraryPromoCreate, libraryPromoUpdate } from 'mixpanel/library/promo'

const PROMO_FORM_ACCORDION = [
  '1. PROMO TYPE & NAME',
  '2. PURCHASE REQUIREMENT',
  '3. REWARD',
  '4. PROMO CONFIGURATION'
]

const tooltip = (
  <Tooltip id='tooltip'>
    Required data is needed
  </Tooltip>
)

class PanelCustomHeaders extends React.Component {
  render () {
    let {opened, promoFormValidity, headerName, detailPromo} = this.props

    return <div>
      <span className={
        !detailPromo
          ? opened
            ? styles['header-title']
            : (!promoFormValidity.submitFailed && !promoFormValidity.isPristine && promoFormValidity.isValid)
              ? styles['header-title']
              : styles['header-title-unactive']
          : styles['header-title']
      }>
        {headerName}
      </span>
      {this._renderHeader()}
    </div>
  }

  _renderHeader = () => {
    let {opened, promoFormValidity, detailPromo} = this.props

    if (!promoFormValidity.submitFailed && !promoFormValidity.isPristine && promoFormValidity.isValid) {
      return <i className={`fa fa-check-circle ${styles['check-logo']}`} />
    } else if (!promoFormValidity.isPristine && (!promoFormValidity.isValid || promoFormValidity.submitFailed)) {
      return <OverlayTrigger placement='top' overlay={tooltip}>
        <i className={`fa fa-exclamation-circle ${styles['times-logo']}`} />
      </OverlayTrigger>
    } else {
      return <i className={!detailPromo
        ? opened ? `fa fa-angle-up ${styles['icon-up']}` : `fa fa-angle-down ${styles['icon-down']}`
        : opened ? `fa fa-angle-up ${styles['icon-up']}` : `fa fa-angle-down ${styles['icon-up']}`} />
    }
  }
}

class PromoForm extends React.Component {
  render () {
    let {handleSubmit, activeAccordion, promoTypeForm, purchaseRequirementForm, rewardForm, detailPromo, promoConfig} = this.props

    let promoPeriod = null
    let promoStatusText = null
    let promoStatusStyle = null
    let promoActivateDeactivateEvent = null
    if (detailPromo) {
      // Determine is promo active, ongoing, or inactive
      let promoActive = detailPromo.active
      // If have start_time, end_time, end_date, then it have time period
      // Otherwise, it doesn't have time period
      // HACK: If the promo has end_date, then it must have start_time and end_time
      let promoStartDate = moment(detailPromo.start_date).format('YYYY-MM-DD')
      if (detailPromo.end_date) {
        let promoEndDate = moment(detailPromo.end_date).format('YYYY-MM-DD')
        promoPeriod = moment().isBetween(promoStartDate, promoEndDate, 'day', '[]') && moment().isSameOrBefore(detailPromo.end_date)
      } else {
        promoPeriod = moment().isSameOrAfter(promoStartDate)
      }
      // TODO: Please evaluate this code after moka-cron has deen deployed for promo
      promoActivateDeactivateEvent = (moment().isBefore(detailPromo.start_date) && promoActive) || (promoActive && promoPeriod) // if true means that it is deactivate
      if (moment().isBefore(detailPromo.start_date) && promoActive) { // promo will be active (scheduled)
        promoStatusText = 'Scheduled'
        promoStatusStyle = styles['text-active']
      } else if (promoActive && promoPeriod) {
        promoStatusText = 'Ongoing'
        promoStatusStyle = styles['text-ongoing']
      } else {
        promoStatusText = 'Inactive'
        promoStatusStyle = styles['text-inactive']
      }
    }

    return (
      <form className={styles.wrapper}>
        <div className={`${styles['field-wrapper']} promo-field-wrapper`}>
          {
            detailPromo && <div className={styles['promo-status-wrapper']}>
              Promo Status : <span className={promoStatusStyle}>{promoStatusText}</span>
            </div>
          }
          <PanelGroup activeKey={activeAccordion} accordion>
            <Panel header={
              <PanelCustomHeaders
                headerName={PROMO_FORM_ACCORDION[0]}
                opened={activeAccordion === '1'}
                promoFormValidity={promoTypeForm}
                detailPromo={detailPromo} />
            } eventKey='1' bsClass={`${styles['promo-headers']} panel`}>

              <PromoTypeAndName onSubmit={() => { this._handleNextButton(2) }} />
            </Panel>
            <Panel header={
              <PanelCustomHeaders
                headerName={PROMO_FORM_ACCORDION[1]}
                opened={activeAccordion === '2'}
                promoFormValidity={purchaseRequirementForm}
                detailPromo={detailPromo} />
            } eventKey='2' bsClass={`${styles['promo-headers']} panel`}>

              <PurchaseRequirement
                selectedOutlets={this._getSelectedOutlets()}
                onSubmit={() => { this._handleNextButton(3) }}
              />
            </Panel>
            <Panel header={
              <PanelCustomHeaders
                headerName={PROMO_FORM_ACCORDION[2]}
                opened={activeAccordion === '3'}
                promoFormValidity={rewardForm}
                detailPromo={detailPromo} />
            } eventKey='3' bsClass={`${styles['promo-headers']} panel`}>

              <Reward
                selectedOutlets={this._getSelectedOutlets()}
                onSubmit={() => { this._handleNextButton(4) }} />
            </Panel>
            <Panel header={
              <PanelCustomHeaders
                headerName={PROMO_FORM_ACCORDION[3]}
                opened={activeAccordion === '4'}
                promoFormValidity={promoConfig}
                detailPromo={detailPromo} />
            } eventKey='4' bsClass={`${styles['promo-headers']} panel`}>

              <PromoConfiguration />
            </Panel>
          </PanelGroup>
        </div>
        <div className={styles.footer}>
          {
            detailPromo && <span>
              <button
                type='button'
                className={`btn btn-danger`}
                onClick={this._clickDelete}>
                <i className={`fa fa-trash`} />
              </button>
              <button
                type='button'
                className={promoActivateDeactivateEvent ? `btn btn-danger ${styles['activate-deactivate-button']}` : `btn btn-primary ${styles['activate-deactivate-button']}`}
                onClick={() => { this._onClickActivateDeactivatePromo(promoActivateDeactivateEvent) }}>
                {!promoActivateDeactivateEvent ? 'Reactivate' : 'Deactivate'}
              </button>
            </span>
          }
          <span className={styles['buttons-wrapper']}>
            <button
              type='button'
              className={`btn btn-default ${styles['btn-cancel']}`}
              onClick={this._onClickCancel}>
                Cancel
            </button>
            {!detailPromo
              ? <button
                className={`btn btn-primary ${styles['btn-save']}`}
                onClick={handleSubmit(this._onSubmit)}
                type='button'
                disabled={activeAccordion !== '4'}>
                Create
              </button>
              : <button
                className={`btn btn-primary ${styles['btn-save']}`}
                onClick={handleSubmit(this._onUpdatePromo)}
                type='button'>
                Save
              </button>}
          </span>
        </div>
      </form>
    )
  }

  _onClickCancel = (event) => {
    this.props.dispatch(onClickCancel())
    event.preventDefault()
    event.stopPropagation()
  }

  _onSubmit = () => {
    // This code will handle create button on Promo Form
    const {promoTypeForm: {formValue}, hashedPromoTypes, promoConfig, businessId, isSubmitPromoForm, outlets} = this.props
    let promoConfigVal = promoConfig.formValues

    const promoCreationData = {
      name: formValue.promoName.trim(),
      promo_type_id: hashedPromoTypes[formValue.promoType.toLowerCase()],
      outlet_ids: this._getSelectedOutlets(),
      multiple: !!promoConfigVal.isAppliesToMultiple,
      business_id: businessId
    }

    let currentMoment = moment().startOf('day')
    if (promoConfigVal.isHaveTimePeriod) {
      // this function will collect days from sunday to saturday
      // if checked, then push TRUE value, otherwise push FALSE value
      promoCreationData['days'] = promoConfigVal.days.map(day => {
        return !!day.checked
      })

      promoCreationData['start_date'] = promoConfigVal.date.startDate
      promoCreationData['end_date'] = promoConfigVal.date.endDate
      /**
       * Convert start_time and end_time to minutes
       * Example 04:00 to 240
       */
      promoCreationData['start_time'] = moment(promoConfig.formValues.hoursFrom).diff(currentMoment, 'minutes')
      promoCreationData['end_time'] = moment(promoConfig.formValues.hoursTo).diff(currentMoment, 'minutes')
    } else {
      promoCreationData['start_date'] = moment().add(1, 'd').startOf('day').toISOString()
      promoCreationData['days'] = [true, true, true, true, true, true, true]
    }

    switch (formValue.promoType.toLowerCase()) {
      case 'buy x get y':
        // Get purchase requirement Buy X Get Y form value
        let prValue = this.props.purchaseRequirementForm.formValuesPR
        // Get reward Buy X Get Y form value
        let rewardValue = this.props.rewardForm.formValues
        // Hashed outlet
        let hashedOutlets = mapKeys(outlets, 'id')
        // Mixpanel track
        let trackedData = {
          'Promo Type': formValue.promoType,
          'Promo Name': formValue.promoName.trim(),
          'Purchase Requirement Type': prValue.purchaseType === 'buyFromItem' ? 'Item' : 'Category',
          'Reward Type': rewardValue.rewardType === 'freeItem' ? 'Free Item' : 'Discount',
          'Promo Configuration': {
            'Assign Outlet Qty': promoCreationData['outlet_ids'].length,
            'Applies in multiple': !!promoConfigVal.isAppliesToMultiple,
            'Time Period': !!promoConfigVal.isHaveTimePeriod
          }
        }
        libraryPromoCreate(trackedData)
        // Dispatch event to saga
        this.props.dispatch(onCreatePromoBuyXGetY(promoCreationData, prValue, rewardValue, isSubmitPromoForm, hashedOutlets))
        break
    }
  }

  _handleNextButton = (key) => {
    let {activeAccordion} = this.props
    // this.props.dispatch(setAccordionActiveKey(key))
    // this.props.dispatch(onSubmitEachPromoForm(isSubmitPromoForm, 'promoTypeAndName', true))

    // this function will handle what next button will do
    switch (activeAccordion) {
      case '1':
        this._submitFirstForm()
        break
      case '2':
        this._submitSecondForm()
        break
      case '3':
        this._submitThirdForm()
        break
      default:
        break
    }
  }

  _submitFirstForm = () => {
    const {promoTypeForm, isSubmitPromoForm, detailPromo, previousAssignedOutlets} = this.props

    // this case will determine which method should be
    // dispatched while user select different type of promo name
    switch (promoTypeForm.formValue.promoType) {
      case 'Buy X Get Y':
        let outlets = this._getSelectedOutlets()
        this.props.dispatch(onSubmitFirstForm(promoTypeForm.formValue, outlets, 'promoTypeAndName', isSubmitPromoForm, detailPromo, (previousAssignedOutlets && previousAssignedOutlets.length !== outlets.length)))
        break
    }
  }

  _submitSecondForm = () => {
    const {purchaseRequirementForm, promoTypeForm, isSubmitPromoForm, detailPromo, previousAssignedOutlets} = this.props
    switch (promoTypeForm.formValue.promoType) {
      case 'Buy X Get Y':
        if (!isSubmitPromoForm.purchaseRequirement) {
          this.props.dispatch(clearSubmitErrors('purchaseRequirement'))
          this.props.dispatch(setSubmitSucceeded('purchaseRequirement'))
        }
        let outlets = this._getSelectedOutlets()
        this.props.dispatch(onSubmitSecondForm(purchaseRequirementForm.formValuesPR, 'purchaseRequirement', isSubmitPromoForm, detailPromo, (previousAssignedOutlets && previousAssignedOutlets.length !== outlets.length)))
        break
    }
  }

  _submitThirdForm = () => {
    const {rewardForm, promoTypeForm, isSubmitPromoForm, detailPromo} = this.props
    switch (promoTypeForm.formValue.promoType) {
      case 'Buy X Get Y':
        this.props.dispatch(onSubmitThirdForm(rewardForm.formValues, 'reward', isSubmitPromoForm, detailPromo))
        break
    }
  }

  handleSubmit = (key) => {
    this.props.dispatch(setAccordionActiveKey(key))
  }

  // This function will get all selected outlets for all steps of the form
  _getSelectedOutlets = () => {
    let {promoTypeForm} = this.props
    let outlets = []
    if (promoTypeForm && promoTypeForm.assignedOutlet && promoTypeForm.assignedOutlet.selectedOutlets.length > 0) {
      promoTypeForm.assignedOutlet.selectedOutlets.map(outlet => {
        if (outlet && outlet.checked) {
          outlets.push(outlet.id)
        }
      })
    }
    return outlets
  }

  _onClickActivateDeactivatePromo = (isActive) => {
    const {detailPromo} = this.props
    if (isActive) {
      this.props.dispatch(onClickDeactivate(detailPromo))
    } else {
      if (detailPromo.end_date) {
        this.props.dispatch(onClickReactivate(detailPromo))
      } else {
        this.props.dispatch(showConfirmReactivateModal())
      }
    }
  }

  _clickDelete = () => {
    const {detailPromo} = this.props
    this.props.dispatch(onClickDelete(detailPromo))
  }

  _onUpdatePromo = () => {
    const {detailPromo, promoTypeForm, promoConfig, dispatch, outlets, isManager} = this.props
    const doesHaveTimePeriod = !!promoConfig.formValues.isHaveTimePeriod // has been initialized when click row

    let newDays = []
    if (promoConfig.formValues && promoConfig.formValues.days.length > 0) {
      promoConfig.formValues.days.forEach((day) => {
        let dayChecked = day.checked
        if (dayChecked === '') {
          dayChecked = false
        }
        newDays.push(dayChecked)
      })
    }

    let outletIds = []
    if (promoTypeForm.formValue && promoTypeForm.formValue.assignedOutlets.length > 0) {
      promoTypeForm.formValue.assignedOutlets.forEach((outlet) => {
        if (outlet.checked) {
          outletIds.push(outlet.id)
        }
      })
    }

    // Check if updated promo has a deleted outlet
    let deletedOutletIds = []
    detailPromo.outlet_ids.map(outlet => {
      if (!includes(outletIds, outlet)) {
        deletedOutletIds.push(outlet)
      }
    })

    // construct deleted_outlets_ids for manager user
    let idsBefore = []
    outlets.map(out => {
      idsBefore.push(out.id)
    })

    let managerOutlets = difference(idsBefore, outletIds)
    let deletedOutletsManager = []

    if (managerOutlets.length > 0) {
      managerOutlets.forEach(del => {
        deletedOutletsManager.push(del)
      })
    }

    // Check if updated promo has an added outlet
    let addedOutletIds = []
    outletIds.map(outlet => {
      if (!includes(detailPromo.outlet_ids, outlet)) {
        addedOutletIds.push(outlet)
      }
    })

    // construct new Data
    let newPromoData = {
      active: detailPromo.active,
      name: promoTypeForm.formValue.promoName.trim(),
      multiple: !!promoConfig.formValues.isAppliesToMultiple,
      added_outlet_ids: addedOutletIds,
      deleted_outlet_ids: !isManager ? deletedOutletIds : deletedOutletsManager
    }

    if (doesHaveTimePeriod) {
      newPromoData['start_date'] = promoConfig.formValues.date.startDate
      newPromoData['end_date'] = promoConfig.formValues.date.endDate
      let currentMoment = moment().startOf('day')
      newPromoData['start_time'] = moment(promoConfig.formValues.hoursFrom).diff(currentMoment, 'minutes')
      newPromoData['end_time'] = moment(promoConfig.formValues.hoursTo).diff(currentMoment, 'minutes')
      newPromoData['days'] = promoConfig.formValues.days.map(day => {
        return !!day.checked
      })
    } else {
      newPromoData['start_date'] = detailPromo.start_date
      newPromoData['end_date'] = null
      newPromoData['start_time'] = null
      newPromoData['end_time'] = null
      newPromoData['days'] = [true, true, true, true, true, true, true]
    }

    let isDaySelected = doesHaveTimePeriod && newPromoData['days'] && newPromoData['days'].length && newPromoData['days'].find((day) => day === true)

    if (!isEmpty(newPromoData)) {
      let hashedOutlets = mapKeys(outlets, 'id')
      // Get outlets name for mixpanel event
      const outletNames = []
      promoTypeForm.assignedOutlet.selectedOutlets.forEach((outlet) => {
        if (outlet.checked) {
          outletNames.push(outlet.name)
        }
      })
      libraryPromoUpdate({
        promoName: promoTypeForm.formValue.promoName.trim(),
        appliesMultiple: !!promoConfig.formValues.isAppliesToMultiple,
        haveTimePeriod: doesHaveTimePeriod,
        assignedOutlet: outletNames
      })
      if (isManager) {
        dispatch(setActionUpdateName('update'))
        dispatch(askConfirmationUpdate(onUpdatePromo(detailPromo.id, newPromoData, hashedOutlets, isDaySelected, doesHaveTimePeriod)))
      } else {
        dispatch(onUpdatePromo(detailPromo.id, newPromoData, hashedOutlets, isDaySelected, doesHaveTimePeriod))
      }
    } else {
      return false
    }
  }
}

const mapForm = {
  form: 'promo'
}

function mapStateToProps (state) {
  let {activeAccordion, isSubmitPromoForm, promoTypes, detailPromo, previousAssignedOutlets, outlets} = state.library.promo
  let promoTypeForm = {
    isValid: isValid('promoTypeAndName')(state),
    isPristine: isPristine('promoTypeAndName')(state),
    formValue: getFormValues('promoTypeAndName')(state),
    assignedOutlet: getFormValues('promoAssignOutlet')(state),
    isDirty: isDirty('promoAssignOutlet')(state)
  }
  let purchaseRequirementForm = {
    isValid: isValid('purchaseRequirement')(state),
    isPristine: isPristine('purchaseRequirement')(state),
    formValuesPR: getFormValues('purchaseRequirement')(state),
    submitFailed: hasSubmitFailed('purchaseRequirement')(state)
  }

  let hashedPromoTypes = {}
  promoTypes.forEach(type => {
    hashedPromoTypes[type.name.toLowerCase()] = type.id
  })

  let rewardForm = {
    isValid: isValid('reward')(state),
    isPristine: isPristine('reward')(state),
    formValues: getFormValues('reward')(state)
  }

  let promoConfig = {
    isValid: isValid('promoConfig')(state),
    isPristine: isPristine('promoConfig')(state),
    formValues: getFormValues('promoConfig')(state)
  }

  let {user} = state.moka
  let businessId = user.business.id
  let isManager = user.is_manager

  return {
    activeAccordion,
    promoTypeForm,
    isSubmitPromoForm,
    purchaseRequirementForm,
    hashedPromoTypes,
    rewardForm,
    promoConfig,
    businessId,
    detailPromo,
    previousAssignedOutlets,
    outlets,
    isManager
  }
}

export default connect(mapStateToProps)(reduxForm(mapForm)(PromoForm))



// WEBPACK FOOTER //
// ./app/pages/Library/Promo/DetailPromo/PromoForm/PromoForm.js